import React, { useEffect, useRef, useState } from "react";
import { v4 as uuid } from "uuid";
import { Bot, SendHorizonal } from "lucide-react";

export default function ChatNorma({ embedded = false, hidden = false }) {
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content: "Ciao! Sono Norma 👋 In cosa posso aiutarti oggi?",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const threadRef = useRef(uuid());
  const boxRef = useRef(null);

  useEffect(() => {
    if (!boxRef.current || hidden) return;
    boxRef.current.scrollTo({
      top: boxRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages, loading, hidden]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;

    setInput("");
    setMessages((m) => [...m, { role: "user", content: text }]);
    setLoading(true);

    try {
      const res = await fetch("/api/norma_chat.php?debug_nozioni=1", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: text,
          thread_id: threadRef.current,
        }),
      });

      const data = await res.json();
      console.log("NORMA DEBUG", data);

      if (data.error) {
        setMessages((m) => [
          ...m,
          {
            role: "assistant",
            content: `⚠️ ${data.error}${data.detail ? " — " + data.detail : ""}`,
          },
        ]);
      } else {
        setMessages((m) => [
          ...m,
          { role: "assistant", content: data.reply || "—" },
        ]);
      }
    } catch (e) {
      setMessages((m) => [
        ...m,
        {
          role: "assistant",
          content: "⚠️ Errore di rete, riprova.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  const containerCls = embedded
    ? "flex h-full min-h-0 flex-col"
    : "mx-auto flex max-w-3xl flex-col p-4 h-[80vh]";

  return (
    <div className={containerCls}>
      {!embedded && (
        <div className="mb-3 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-100 text-emerald-700">
            <Bot size={18} />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-slate-900">Parla con Norma</h1>
            <p className="text-sm text-slate-500">
              Assistente HACCP della tua azienda
            </p>
          </div>
        </div>
      )}

      <div
        ref={boxRef}
        className="flex-1 min-h-0 overflow-y-auto rounded-2xl border border-slate-200 bg-slate-50 p-3"
      >
        <div className="space-y-3">
          {messages.map((m, i) => {
            const isUser = m.role === "user";

            return (
              <div
                key={i}
                className={`flex ${isUser ? "justify-end" : "justify-start"}`}
              >
                <div
                  className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm shadow-sm whitespace-pre-wrap ${isUser
                      ? "bg-slate-900 text-white rounded-br-md"
                      : "bg-white text-slate-800 border border-slate-200 rounded-bl-md"
                    }`}
                >
                  {m.content}
                </div>
              </div>
            );
          })}

          {loading && (
            <div className="flex justify-start">
              <div className="rounded-2xl rounded-bl-md border border-slate-200 bg-white px-4 py-3 text-sm text-slate-500 shadow-sm">
                Sto pensando…
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mt-3 flex items-end gap-2">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={onKey}
          rows={2}
          className="min-h-[52px] max-h-36 flex-1 resize-y rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100"
          placeholder="Chiedi a Norma… (Invio per inviare, Shift+Invio per andare a capo)"
        />
        <button
          onClick={send}
          disabled={loading || !input.trim()}
          className="inline-flex h-[52px] items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 text-sm font-medium text-white shadow-sm transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <SendHorizonal size={16} />
          <span>Invia</span>
        </button>
      </div>
    </div>
  );
}